import React from "react";
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import {Breadcrumbs as BreadcrumbsMUI} from '@mui/material';
import Link from '@mui/material/Link';
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
const breadcrumbsStructureData = (listOfItems) => {
    const schema = document.createElement("script");
    const items = listOfItems.filter(f => f.url).map((element, index) => {
        let itemsObj = {
            "@type": "ListItem",
            "position": index,
            "name": element.name
        };
        if (element.url !== "#") itemsObj["item"] = element.url;
        return itemsObj;
    });
    const schemaStructure = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items
    };
    schema.type = "application/ld+json";
    schema.text = JSON.stringify([schemaStructure]);
    document.querySelector("head").appendChild(schema);
};

const Breadcrumbs = props => {
    const theme = useTheme();
    let list = [
        {
            url: ConfigurationHelper.getGlobalConfiguration().public_base_url + ConfigurationHelper.getGlobalConfiguration().sub_folder + "/",
            name: "Home",
            active: false
        }
    ];
    if(props.isHomePage){
        list.push({
            url: ConfigurationHelper.getGlobalConfiguration().public_base_url + ConfigurationHelper.getGlobalConfiguration().sub_folder + "/",
            name: "Aero A-Team",
            active: true
        });
    }
    list = [...list, ...props.breadcrumbsList];
    if (props.renderStructureData)
        breadcrumbsStructureData(list);

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Container maxWidth="xl" sx={{py: 2}}>
            <Box display={"flex"} justifyContent="space-between" role="presentation">
                <BreadcrumbsMUI aria-label="breadcrumb">
                    {list.filter(f=> {
                        if(isMobile){
                            if(f.hideMobile === true)
                                return false;
                        }
                        return true;
                    }).map((item, index) => {

                        return (<Link
                            sx={{
                                fontSize: "12px"
                            }}
                            key={index}
                            underline="hover"
                            color={(item.active ? "inherit" : "text.primary")}
                            href={item.url}
                            aria-current="page"
                        >
                            {item.name}
                        </Link>)
                    })}
                </BreadcrumbsMUI>
            </Box>
        </Container>
    );
};

Breadcrumbs.defaultProps = {
    breadcrumbsList: [],
    isHomePage: false,
    renderStructureData: true
};
export default Breadcrumbs;